import { store } from '../../store'
import { httpgst } from '../../main'

// initial state
const state = {}

// getters
const getters = {}

// actions
const actions = {
  getSearch ({ commit, dispatch }, payload) {
    let url = 'api/expenses-filters?' + payload.event.select + '=' + payload.event.id
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options)
      .then(response => {
        commit('onGet', { event: payload.event, response: response })
      }, error => {
        commit('onError', { event: payload.event, error: error })
      })
  },
  downloadRequest ({ commit, dispatch }, payload) {
    let url = `api/travel-expenses-request/to-pdf/` + payload.event.item
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/pdf'
      }
    }
    let params = {
      responseType: 'blob'
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, params, options)
      .then(
        response => {
          commit('onDownloadRequest', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  downloadFilesZip ({ commit, dispatch }, payload) {
    let url = `api/expenses/zip/by-user/` + payload.event.item.user_id
    let config = {
      responseType: 'blob'
    }
    let params = {
      expense_id: payload.event.item.id,
      start_date: payload.event.item.start_date ? payload.event.item.start_date : undefined,
      end_date: payload.event.item.end_date ? payload.event.item.end_date : undefined
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.post(url, params, config)
      .then(
        response => {
          commit('onDownloadFilesZip', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  }
}

// mutations
const mutations = {
  onGet (state, payload) {
    payload.event.context.items = payload.response.data.data

    if (payload.event.context.items && payload.event.context.items.length > 0 && payload.event.context.items[0].has_multiprojects === 1) {
      const processed = {}
      payload.event.context.items[0].gst_expenses_items.sort((a, b) => a.project_id - b.project_id)
      payload.event.context.items[0].gst_expenses_items.forEach(item => {
        item.has_multiprojects = true
        item.titleName = item.project_id ? payload.event.context.items[0].multiprojects.find(x => x.id === item.project_id).name : ''
        if (item.project_id && !processed[item.project_id]) {
          item.isTitle = true
          processed[item.project_id] = true
        } else {
          item.isTitle = false
        }
      })
    }

    payload.event.context.Sloading = false
  },
  onDownloadRequest (state, payload) {
    payload.event.context.forceFileDownload(payload.response.data, 'Request-' + payload.event.item.folio + '.pdf')
    payload.event.context.loadingDownload = false
  },
  onDownloadFilesZip (state, payload) {
    payload.event.context.forceFileDownload(payload.response.data, 'ExpensesUserFiles' + ` ${payload.event.item.id}_${payload.event.item.start_date}_${payload.event.item.end_date}.zip`)
    payload.event.context.loadingFilesZip = false
  },
  onError (state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.Sloading = false
      payload.event.context.errors = payload.error.response.data.errors
    }
    if (payload.error.response.status === 401) {
      payload.event.context.showNotification(payload.event.context.$t('login.sessionExpired'), 'error', -1)
      setTimeout(() => { payload.event.context.$router.push({ name: 'LoginPage' }) }, 2000)
    } else {
      payload.event.context.showNotification(payload.error.response, 'error', -1)
    }
    payload.event.context.Sloading = false
    payload.event.context.loadingDownload = false
    payload.event.context.loadingFilesZip = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/generalSearch.js